import React from 'react';

function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 md:p-10">
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
              Пользовательское соглашение
            </h1>
            <p className="text-sm text-gray-500">
              Версия 1.1 от 17 января 2025 г.
            </p>
          </div>

          <div className="prose prose-sm md:prose-base max-w-none text-gray-700 space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Общие положения</h2>
              <p>
                Настоящее Пользовательское соглашение (далее — «Соглашение») определяет условия использования 
                информационной системы SkillGate (далее — «Сервис»), принадлежащей Индивидуальному предпринимателю 
                Вихляеву Сергею Николаевичу (далее — «Исполнитель»).
              </p>
              <p>
                Использование Сервиса означает полное и безоговорочное принятие Пользователем всех условий 
                настоящего Соглашения. В случае несогласия с условиями Соглашения Пользователь не вправе 
                использовать Сервис.
              </p>
              <p>
                Настоящее Соглашение разработано в соответствии с законодательством Российской Федерации, включая:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Гражданский кодекс Российской Федерации;</li>
                <li>Федеральный закон от 27.07.2006 № 149-ФЗ «Об информации, информационных технологиях и о защите информации»;</li>
                <li>Федеральный закон от 27.07.2006 № 152-ФЗ «О персональных данных»;</li>
                <li>Иные нормативные правовые акты Российской Федерации.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Термины и определения</h2>
              <dl className="space-y-3">
                <dt className="font-semibold">Сервис</dt>
                <dd className="ml-4">Разработанный программный комплекс SkillGate, доступный по адресу https://skillgate.pro, предназначенный для проведения скрининг-тестирования кандидатов.</dd>
                
                <dt className="font-semibold">Пользователь</dt>
                <dd className="ml-4">Физическое или юридическое лицо, зарегистрированное в Сервисе и использующее его функционал.</dd>
                
                <dt className="font-semibold">Кандидат</dt>
                <dd className="ml-4">Физическое лицо, проходящее тестирование в рамках использования Сервиса.</dd>
                
                <dt className="font-semibold">Исполнитель</dt>
                <dd className="ml-4">Индивидуальный предприниматель Вихляев Сергей Николаевич, являющийся владельцем и администратором Сервиса.</dd>
              </dl>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Предмет Соглашения</h2>
              <p>
                Исполнитель оказывает Пользователю услуги по <strong>разработке программного обеспечения</strong> 
                и <strong>подключению к разработанному сервису</strong> SkillGate на условиях, установленных 
                настоящим Соглашением.
              </p>
              <p>
                Разработанный программный комплекс SkillGate предоставляет Пользователю следующие возможности:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Создание и управление базами вопросов для тестирования;</li>
                <li>Создание тест-схем на основе баз вопросов;</li>
                <li>Генерация уникальных ссылок-приглашений для кандидатов;</li>
                <li>Проведение тестирования кандидатов через специальное мобильное приложение;</li>
                <li>Получение результатов тестирования и аналитики;</li>
                <li>Сравнение результатов различных кандидатов.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Регистрация и учетная запись</h2>
              <p>
                Для использования Сервиса Пользователь должен пройти процедуру регистрации, указав следующие данные:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Название компании или организации;</li>
                <li>Адрес электронной почты;</li>
                <li>Пароль для доступа к учетной записи.</li>
              </ul>
              <p>
                Пользователь обязуется предоставлять достоверную информацию при регистрации и поддерживать 
                ее актуальность.
              </p>
              <p>
                Пользователь несет ответственность за сохранность своих учетных данных и за все действия, 
                совершенные под его учетной записью.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Права и обязанности Пользователя</h2>
              <p>
                <strong>Пользователь вправе:</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Использовать функционал Сервиса в соответствии с его назначением;</li>
                <li>Создавать неограниченное количество баз вопросов, тест-схем и приглашений;</li>
                <li>Получать техническую поддержку от Исполнителя;</li>
                <li>Требовать удаления своей учетной записи и данных.</li>
              </ul>
              <p>
                <strong>Пользователь обязуется:</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Не использовать Сервис в незаконных целях;</li>
                <li>Не передавать свои учетные данные третьим лицам;</li>
                <li>Не предпринимать попыток взлома, нарушения работы или безопасности Сервиса;</li>
                <li>Не размещать в Сервисе информацию, нарушающую права третьих лиц или законодательство РФ;</li>
                <li>Соблюдать требования настоящего Соглашения.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Права и обязанности Исполнителя</h2>
              <p>
                <strong>Исполнитель обязуется:</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Обеспечивать работоспособность разработанного программного комплекса SkillGate в соответствии с его функциональным назначением;</li>
                <li>Применять меры по защите данных Пользователей;</li>
                <li>Хранить все данные на территории Российской Федерации;</li>
                <li>Предоставлять техническую поддержку Пользователям по вопросам использования разработанного программного обеспечения.</li>
              </ul>
              <p>
                <strong>Исполнитель вправе:</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Приостанавливать работу разработанного программного комплекса для проведения технических работ;</li>
                <li>Блокировать учетные записи Пользователей при нарушении условий Соглашения;</li>
                <li>Вносить изменения в функционал разработанного программного комплекса;</li>
                <li>Изменять условия настоящего Соглашения с уведомлением Пользователей.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Хранение данных</h2>
              <p>
                Все данные, обрабатываемые разработанным программным комплексом SkillGate, хранятся на территории Российской Федерации. 
                Хостинг-провайдером является ООО «Регистратор доменных имен РЕГ.РУ» (reg.ru).
              </p>
              <p>
                Разработанный программный комплекс SkillGate <strong>не предназначен для обработки персональных данных</strong> 
                в понимании Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Интеллектуальная собственность</h2>
              <p>
                Все объекты интеллектуальной собственности, включая разработанное программное обеспечение, дизайн, 
                текстовое и графическое содержание программного комплекса SkillGate, являются собственностью Исполнителя 
                или используются на законных основаниях.
              </p>
              <p>
                Пользователь не вправе копировать, воспроизводить, распространять или иным образом 
                использовать объекты интеллектуальной собственности без письменного согласия Исполнителя.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Ответственность</h2>
              <p>
                Исполнитель не несет ответственности за:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Результаты тестирования кандидатов и решения, принятые на их основе;</li>
                <li>Действия Пользователей, нарушающие законодательство РФ или права третьих лиц;</li>
                <li>Временные сбои в работе Сервиса, связанные с техническими работами или форс-мажорными обстоятельствами;</li>
                <li>Ущерб, причиненный в результате использования или невозможности использования Сервиса.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Изменение и расторжение Соглашения</h2>
              <p>
                Исполнитель вправе в одностороннем порядке изменять условия настоящего Соглашения. 
                Актуальная версия Соглашения всегда доступна на странице 
                <a href="https://skillgate.pro/terms-of-service" className="text-blue-600 hover:underline"> https://skillgate.pro/terms-of-service</a>.
              </p>
              <p>
                Пользователь вправе в любой момент прекратить использование Сервиса и удалить свою учетную запись.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Контактная информация</h2>
              <p>
                По всем вопросам, связанным с использованием Сервиса, Пользователи могут обращаться к Исполнителю:
              </p>
              <p>
                <strong>Индивидуальный предприниматель Вихляев Сергей Николаевич</strong>
              </p>
              <p>
                ИНН: 682004283576
              </p>
              <p>
                Электронная почта: <a href="mailto:skillgate.pro@gmail.com" className="text-blue-600 hover:underline">skillgate.pro@gmail.com</a>
              </p>
              <p>
                Сайт: <a href="https://skillgate.pro" className="text-blue-600 hover:underline">https://skillgate.pro</a>
              </p>
            </section>
          </div>

          <div className="mt-10 pt-6 border-t border-gray-200 text-sm text-gray-500">
            <p>Дата последнего обновления: 17 января 2025 г.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;

